module.exports = __webpack_public_path__ + "img/member_default.33e87df.jpg";